import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import tailwindClassnames from "../common/TailwindClassnames";
import TextInput from "../common/TextInput";
import { BeatLoader } from "react-spinners";

interface DecommissionSensorConfirmationModalProps {
  isOpen: boolean;
  confirmationMessage: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  decommission_reason: string | null;
  onDecommissionReasonChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  saving?: boolean;
}

const DecommissionSensorConfirmationModal: React.FC<
  DecommissionSensorConfirmationModalProps
> = ({
  isOpen,
  confirmationMessage,
  onConfirm,
  onCancel,
  confirmLabel,
  decommission_reason,
  onDecommissionReasonChange,
  saving,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={`${tailwindClassnames.modalOverlay} z-50`}>
      <div className={`${tailwindClassnames.modalPanel} max-w-md`}>
        <div className={tailwindClassnames.modalHeaderRow}>
          <div className="flex items-center gap-3">
            <span
              aria-hidden="true"
              className={tailwindClassnames.modalDangerIcon}
            >
              !
            </span>
            <h2 className={tailwindClassnames.modalTitle}>{t("Confirm")}</h2>
          </div>
          <button
            type="button"
            className={tailwindClassnames.modalCloseButton}
            onClick={onCancel}
            disabled={saving}
            aria-label={t("Close")}
          >
            &times;
          </button>
        </div>
        <div className={tailwindClassnames.modalBody}>
          <p className="mb-4">{confirmationMessage}</p>
          <TextInput
            name="decommission_reason"
            label={t("Decommission Reason")}
            placeholder={t("Describe reason for decommission")}
            value={decommission_reason ? decommission_reason : ""}
            disabled={false}
            className={tailwindClassnames.detailsPageTextInput}
            limit={2000}
            type="text"
            rows={3}
            onChange={onDecommissionReasonChange}
          />
        </div>
        <div className={tailwindClassnames.modalFooter}>
          <button
            type="button"
            className={tailwindClassnames.btnSecondary}
            onClick={onCancel}
            disabled={saving}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className={`relative ${tailwindClassnames.btnDanger}`}
            onClick={onConfirm}
            disabled={saving}
          >
            {/* Label stays in layout while saving so the button keeps its
                width; currentColor spinner reads on the red fill in both
                themes. */}
            <span className={saving ? "invisible" : ""}>
              {confirmLabel ? confirmLabel : t("Yes")}
            </span>
            {saving && (
              <span className="absolute inset-0 flex items-center justify-center">
                <BeatLoader
                  color="currentColor"
                  loading={true}
                  size={10}
                  margin={5}
                />
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DecommissionSensorConfirmationModal;
